import { useCallback } from 'react';

import { CONTEXT25_CAMPAIGN_DISMISSED_KEY } from 'constants/notification-bar';
import { saveItem, getItem } from 'services/session-storage';

interface UseContext25StorageReturn {
  markDismissed: () => void;
  isDismissed: () => boolean;
}

export function useContext25Storage(): UseContext25StorageReturn {
  const markDismissed = useCallback((): void => {
    saveItem(CONTEXT25_CAMPAIGN_DISMISSED_KEY, true);
  }, []);

  const isDismissed = useCallback((): boolean => {
    return Boolean(getItem<boolean>(CONTEXT25_CAMPAIGN_DISMISSED_KEY));
  }, []);

  return {
    markDismissed,
    isDismissed,
  };
}
